import { EyeOutlined, FileTextOutlined } from "@ant-design/icons";
import { Button, Empty, Popover, Space, TableColumnsType } from "antd";
import { ResponseGetDictumsDetails } from "api/generated";
import DownloadJsonIcon from "common/components/DownloadJsonIcon";
import DownloadPdfIcon from "common/components/DownloadPdfIcon";
import { ResponsiveTable } from "common/components/table/ResponsiveTable";
import { UsePaginationTableReturn } from "hooks/commons/usePaginationTable";
import { useMemo } from "react";

interface DictumTableProps {
  pagination: UsePaginationTableReturn<ResponseGetDictumsDetails>;
  isLoading: boolean;
  handleDownload: (dictumId: string, fileType: "pdf" | "json") => void;
  handleEdit: (dictumId: string) => void;
}

function DictumsTable({
  pagination,
  isLoading,
  handleDownload,
  handleEdit,
}: DictumTableProps) {
  const dictums = useMemo(() => pagination.items, [pagination.items]);

  const columns: TableColumnsType<ResponseGetDictumsDetails> = [
    {
      title: "Folio",
      dataIndex: "dictumFolioDetail",
      width: "15%",
      align: "center",
    },
    {
      title: "Emisión del Dictamen",
      dataIndex: "dictumIssueDateDetail",
      align: "center",
      width: "12%",
    },
    {
      title: "Fecha Muestra",
      dataIndex: "dictumSampleTakenDetail",
      align: "center",
      width: "12%",
    },
    {
      title: "Fin Resultados",
      dataIndex: "dictumTestResultDate",
      align: "center",
      width: "12%",
    },
    {
      title: "Método",
      dataIndex: "dictumTestMethod",
      width: "15%",
      align: "center",
    },
    {
      title: "Resultado",
      dataIndex: "dictumTestResult",
      width: "12%",
      align: "center",
    },
    {
      title: "Acciones",
      fixed: "right",
      width: "12%",
      align: "center",
      render: (_, record) => {
        const dictumId = record.dictumId;
        if (!dictumId) return;
        return (
          <Space>
            <Popover content="Descargar JSON">
              <Button
                icon={<DownloadJsonIcon />}
                onClick={() => handleDownload(dictumId, "json")}
              />
            </Popover>
            <Popover content="Descargar PDF">
              <Button
                icon={<DownloadPdfIcon />}
                onClick={() => handleDownload(dictumId, "pdf")}
              />
            </Popover>
            <Popover>
              <Button
                icon={<EyeOutlined />}
                onClick={() => handleEdit(dictumId)}
              />
            </Popover>
          </Space>
        );
      },
    },
  ];

  return (
    <ResponsiveTable
      columns={columns}
      loading={isLoading}
      locale={{ emptyText: <Empty description="Sin registros" /> }}
      dataSource={dictums}
      rowKey="dictumId"
      pagination={{
        ...pagination.paginationConfig,
        onChange: pagination.onPageChange,
        onShowSizeChange: pagination.onPageSizeChange,
      }}
      scroll={{
        y: "calc(100vh - 200px)",
      }}
      titleDataIndex="dictumFolioDetail"
      titleIcon={<FileTextOutlined style={{ color: "#1677ff" }} />}
    />
  );
}

export default DictumsTable;
